export default function AddressCheckerApi({ makeRequest, buildRequest }) {

    function suggestAddresses(query, max = 10) {
        return buildRequest().then(function (req) {
            return makeRequest(
                req.get('/api/AddressChecker/Suggest', {
                    params: { q: query, max },
                    suppressErrorToast: true,
                })
            );
        });
    }

    function getAddressDetails(dpid) {
        return buildRequest().then(function (req) {
            return makeRequest(
                req.get(`/api/AddressChecker/Details/${encodeURIComponent(dpid)}`, {
                    suppressErrorToast: true,
                })
            );
        });
    }

    return {
        suggestAddresses,
        getAddressDetails,
    };
}
